<template>

  <div id="accordionExample">
    <b-table-simple bordered>
      <b-thead class="entete-anomalie">
        <b-tr>
          <b-th class="colonne">n° Anomalie</b-th>
          <b-th v-for="champ in nomChamps"
                v-bind:key="champ"
                class="colonne">{{champ}}
          </b-th>
          <b-th class="colonne">Justification</b-th>
          <b-th class="colonne">Type</b-th>
          <b-th class="colonne">Validation</b-th>
          <b-th class="colonne">Editer</b-th>
        </b-tr>
      </b-thead>
      <b-tbody class ="tableau-anomalie">
        <b-tr v-for="anomalie in anomalies"
              v-bind:key="anomalie.idAnomalie"
              v-bind:anomalie="anomalie">
          <b-td> {{anomalie.idAnomalie}}</b-td>
          <b-td v-for ="champ in anomalie.champsLigneAnomalie"
                v-bind:key="champ.idChampLigneAnomalie"
                v-bind:champ="champ">{{champ.valeurChamp}}
          </b-td>
          <b-td v-if="anomalie.justification != null">{{anomalie.justification}}</b-td>
          <b-td v-else class="boutton">
            <b-button @click.prevent ="anomalie.showModalValidJustifAnomalie = !anomalie.showModalValidJustifAnomalie"
                      align-self="center"
                      title="justifier l'anomalie" >justifier
            </b-button>
          </b-td>

          <b-modal v-model="anomalie.showModalValidJustifAnomalie" class="col-md-12" hide-header hide-footer centered>
            <ModalValidJustifAnomalie
                :idAnomalie="anomalie.idAnomalie"
                @close="anomalie.showModalValidJustifAnomalie = false"
                class="col-md-12">
            </ModalValidJustifAnomalie>
          </b-modal>

          <b-td>{{anomalie.type}}</b-td>
          <b-td v-if="anomalie.validation === 1" style="color: forestgreen">Validé</b-td>
          <b-td v-else-if="anomalie.validation === 0">
            <p style="color: red"> Refusé</p>
            <p data-toggle="collapse" :data-target="'#collapse' + anomalie.idAnomalie" aria-expanded="true" :aria-controls="'#collapse' + anomalie.idAnomalie" style="text-decoration: underline; cursor: pointer">Voir le commentaire</p>
            <div :id="'collapse' + anomalie.idAnomalie" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
              <p v-if="anomalie.commentaire != null"><strong>{{anomalie.commentaire}}</strong></p>
              <p v-else><strong>Pas de commentaire pour cette anomalie</strong></p>
            </div>
          </b-td>
          <b-td v-else-if="anomalie.validation === 2" style="color: orange">En Attente</b-td>
          <b-td v-else></b-td>
          <b-td v-if="anomalie.type === 'justification'">
            <b-button @click.prevent ="anomalie.showModalEditerJustifAnomalie = !anomalie.showModalEditerJustifAnomalie " align-self="center"
                      title="editer la justification" >Editer
            </b-button>
          </b-td>

          <b-modal v-model="anomalie.showModalEditerJustifAnomalie" class="col-md-12" hide-header hide-footer centered>
            <ModalEditerJustifAnomalie
                :idAnomalie="anomalie.idAnomalie"
                @close="anomalie.showModalEditerJustifAnomalie = false"
                class="col-md-12">
            </ModalEditerJustifAnomalie>
          </b-modal>

        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>

</template>

<script>
import { ref } from "vue";
import ModalValidJustifAnomalie from '@/components/RapportSansConnexion/InsertJustificationWithoutConnexion';
import ModalEditerJustifAnomalie from '@/components/RapportSansConnexion/EditerJustifWithoutConnexion.vue';

export default {
  name: 'AnomaliesItem',

  components:{
    ModalValidJustifAnomalie,
    ModalEditerJustifAnomalie,
  },

  props: {
    idExecution:{
      type:Number
    },
    idRequete:{
      type:Number
    },
    anomalies:{
      required:true,
      type:Array
    },
    nomChamps:{
      type:Array
    },

  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    const showModalValidJustifAnomalie = ref(false);
    const showModalEditerJustifAnomalie = ref(false);
    const anomalie = ref({});
    const commentaire = ref("Refus de la justification");

    props.anomalies.forEach((anomalie) => {
      anomalie.showModalValidJustifAnomalie = false;
      anomalie.showModalEditerJustifAnomalie = false;
    });

    return {
      showModalValidJustifAnomalie,
      showModalEditerJustifAnomalie,
      anomalie,
      commentaire,
    };
  },
};
</script>

<style>
.colonne{
  width: 120px;
}
.tableau-anomalie{
  font-size: 13px;
  text-align : center;
  background-color: white;
}
.entete-anomalie{
  font-size: 13px;
  background-color: silver;
  text-align : center;
}
</style>